import React, { useState, useEffect } from "react";
import PublicFormValidated from "./PublicFormValidated";
import "./PublicForm.css";
import bymoLogo from "../../img/bymo.png";

const API_BASE_URL = process.env.NODE_ENV === 'development' 
    ? 'http://127.0.0.1:8080'
    : 'https://bymolive-backend-995926394015.us-central1.run.app';

const PublicForm = () => {
    const [instagramProfile, setInstagramProfile] = useState("");
    const [message, setMessage] = useState("");
    const [isProfileFound, setIsProfileFound] = useState(false);
    const [validatedProfileData, setValidatedProfileData] = useState(null);
    const [isLoadingProfile, setIsLoadingProfile] = useState(false);


    const handleCheckProfile = async () => {
        if (!instagramProfile.trim()) {
            setMessage("Te rugam sa introduci un profil de Instagram valid.");
            return;
        }

        setIsLoadingProfile(true);
        setMessage("Se verifica profilul...");
        
        console.log("Checking profile:", instagramProfile);
        
        try {
            // Call the backend to CHECK the profile (not validate which creates it)
            const url = `${API_BASE_URL}/api/onboarding/check-profile?profile=${encodeURIComponent(instagramProfile.toLowerCase())}`;
            console.log("API URL:", url);
            
            const response = await fetch(url);
            
            console.log("API Response Status:", response.status);
            console.log("API Response OK:", response.ok);
            
            // Log the raw response for debugging
            const responseClone = response.clone();
            const rawResponse = await responseClone.text();
            console.log("Raw API Response:", rawResponse);
            
            // Handle different HTTP status codes
            if (response.status === 404) {
                console.log("404 Error: Server not found");
                throw new Error("Serverul nu a putut fi contactat. Te rugăm să încerci mai târziu.");
            } else if (response.status === 403) {
                console.log("403 Error: Profile not eligible");
                let errorMessage = "Profilul tău nu este încă eligibil pentru program. Te rugăm să ne contactezi pentru mai multe informații.";
                
                try {
                    const errorData = JSON.parse(rawResponse);
                    if (errorData && errorData.error) {
                        errorMessage = errorData.error;
                        console.log("Parsed error message:", errorMessage);
                    }
                } catch (parseError) {
                    console.error("Error parsing 403 response:", parseError);
                }
                
                throw new Error(errorMessage);
            } else if (!response.ok) {
                console.log("Other Error:", response.status);
                let errorMessage = "A apărut o eroare la verificarea profilului.";
                
                try {
                    const errorData = JSON.parse(rawResponse);
                    if (errorData && errorData.error) {
                        errorMessage = errorData.error;
                        console.log("Parsed error message:", errorMessage);
                    }
                } catch (parseError) {
                    console.error("Error parsing error response:", parseError);
                }
                
                throw new Error(errorMessage);
            }
            
            // Parse the JSON response
            let data;
            try {
                data = JSON.parse(rawResponse);
                console.log("Parsed API Response Data:", data);
            } catch (parseError) {
                console.error("Error parsing JSON response:", parseError);
                throw new Error("Eroare la procesarea răspunsului de la server.");
            }
            
            // If no profile data is returned, throw an error
            if (!data || !data.profile) {
                console.log("No profile data in response");
                throw new Error("Profilul tău nu este încă eligibil pentru program. Te rugăm să ne contactezi pentru mai multe informații.");
            }
            
            // Clear any previous error message
            setMessage(""); 
            
            // Store the validated profile data
            console.log("Setting validated profile data:", data.profile);
            setValidatedProfileData(data.profile);
            
            // Set profile as found
            setIsProfileFound(true);
            
        } catch (error) {
            console.error("Profile validation error:", error);
            console.error("Error stack:", error.stack);
            setMessage(error.message || "Profilul tău nu este încă eligibil pentru program. Te rugăm să ne contactezi pentru mai multe informații.");
            setIsProfileFound(false);
            setValidatedProfileData(null);
        } finally {
            setIsLoadingProfile(false);
        }
    };

    // If profile is validated, show the full form
    if (isProfileFound && validatedProfileData) {
        return <PublicFormValidated profileData={validatedProfileData} />;
    }

    // Otherwise, show just the profile validation form
    return (
        <div className="form-container">
            <div className="form-header">
                <img src={bymoLogo} alt="BYMO Logo" className="logo" />
                <h2>BYMO Onboarding</h2>
            </div>
            
            <div className="profile-validation-container">
                <h3>Introdu profilul tău de Instagram</h3>
                <div className="profile-input-group">
                    <input
                        type="text"
                        value={instagramProfile}
                        onChange={(e) => setInstagramProfile(e.target.value)}
                        placeholder="Profil Instagram (fără @)"
                        className="input-field"
                    />
                    <button 
                        onClick={handleCheckProfile}
                        disabled={isLoadingProfile}
                        className="action-button"
                    >
                        {isLoadingProfile ? "Se verifică..." : "Verifică"}
                    </button>
                </div>
                
                {message && (
                    <div className={`message ${message.includes("eligibil") ? "error-message" : "info-message"}`}>
                        {message}
                    </div>
                )}
                
                <div className="instructions">
                    <p>Introdu numele profilului tău de Instagram pentru a verifica eligibilitatea.</p>
                    <p>Exemplu: bymo.ro (fără @)</p>
                </div>
            </div>
        </div>
    );
};

export default PublicForm;
